export default "__VITE_ASSET__Dbu4qNwO__"